module.exports = __webpack_public_path__ + "img/logo-transparent2.d3aa57b7.png";